import { type ReactElement, type ReactNode } from 'react';

import { CloseButton } from '../buttons';

import { type ActionsContainerProps } from './components/actions-container';
import { type ContentContainerProps } from './components/content-container';
import { type TitleContainerProps } from './components/title-container';
import {
  ActionsContainer,
  ContentContainer,
  StyledDrawer,
  type StyledDrawerProps,
  TitleContainer,
} from './components';

export type DrawerProps = StyledDrawerProps & {
  title: ReactNode;
  content: ReactNode;
  actions: ReactNode;
  TitleContainerProps?: TitleContainerProps;
  ContentContainerProps?: ContentContainerProps;
  ActionsContainerProps?: ActionsContainerProps;
};

export const Drawer = ({
  title,
  content,
  actions,
  TitleContainerProps,
  ContentContainerProps,
  ActionsContainerProps,
  ...props
}: DrawerProps): ReactElement => {
  const handleClose = (): void => {
    props.onClose({}, 'backdropClick');
  };

  return (
    <StyledDrawer {...props}>
      <TitleContainer {...TitleContainerProps}>
        {title}
        <CloseButton onClick={handleClose} />
      </TitleContainer>

      <ContentContainer {...ContentContainerProps}>{content}</ContentContainer>

      <ActionsContainer {...ActionsContainerProps}>{actions}</ActionsContainer>
    </StyledDrawer>
  );
};
